import {ForgotSchema} from '@/forms/Forgot'
import {Form, Formik} from 'formik'
import {Dispatch, SetStateAction} from 'react'
import PhoneInput from '../forms/PhoneInput'
import SubmitButton from '../forms/SubmitButton'

interface Props {
  handleSubmitPhone: any
  mutation: any

  setIso2: Dispatch<SetStateAction<string>>
}
export default function ForgotLoginPhoneForm({
  handleSubmitPhone,
  mutation,
  setIso2,
}: Props) {
  return (
    <Formik
      initialValues={{
        phone: '',
        country_code: '',
      }}
      validationSchema={ForgotSchema}
      onSubmit={handleSubmitPhone}>
      {({errors, touched, values, setFieldError, setFieldValue}) => (
        <Form>
          <div className="form mt-4">
            <div className="form-group flex flex-col">
              <PhoneInput
                values={values}
                setFieldError={setFieldError}
                setFieldValue={setFieldValue}
                isError={errors.phone && touched.phone}
                error={errors.phone}
                setIso2={setIso2}
                label="اكتب رقم هاتفك*"
              />
            </div>

            <SubmitButton
              isLoading={mutation.isLoading}
              text={'ارسال كلمة مرور جديدة'}
              textType="string"
            />
          </div>
        </Form>
      )}
    </Formik>
  )
}
